import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { Head } from '@_/components';
import { BookingsPage } from '#src/pages/BookingsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/bookings')({
  component: RouteComponent,
  validateSearch: z.object({
    tab: z.enum(['cancelled', 'past', 'upcoming']).optional().default('upcoming').catch('upcoming')
  })
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.bookings-page',
            defaultMessage: 'Bookings'
          })}
        </title>
      </Head>

      <BookingsPage />
    </>
  );
}
